import {cs}               from "@Common/react/chain-services";
import {Static2}          from "@Common/react/static-2";
import {itemEditor}       from "@Common/ui-components/heavy/item-options/modules/expo-types/expo-types";
import {ErrorHighlighter} from "@Common/ui-components/light/error-highlighter";
import {scrollIntoView}   from "@Common/ui-components/light/scroll-into-view";

import {ShippingQuantity} from "../../../../../common/heavy/shipping-quantity/shipping-quantity";

export const quantityModules = ({}) => [
    {
        name: "quantityUi",
        load: ({quantity2, paperPrices, paperPrice}, rootNext) => cs(
            ["eh", (_, next) => ErrorHighlighter({next})],
            ["domRef", (_, next) => Static2({next})],
            ({eh, domRef}) => rootNext(quantity2 && {
                itemEditor: {
                    $name: "quantity",

                    errorsHandling: {
                        highlightErrors: () => {
                            scrollIntoView(domRef.get());
                            eh.start();
                        },
                    },

                    valid: !!paperPrice,
                },
                ui: ({showErrors}) => ShippingQuantity({
                    state: quantity2.state,
                    domRef: domRef.set,
                    eh,
                    paperPrices,
                    showErrors,
                    paperPrice,
                }),
            }),
        ),
        requires: ["quantity2", "paperPrices", "paperPrice"],
        expo: [itemEditor], // No need exporting UI, as this is accessed directly in top-control module
    },
];